import { createRouter, createWebHashHistory } from 'vue-router'
import open from '@/layout/open'
import platform from '@/layout/platform'
import emptyPrint from '@/layout/emptyPrint'
import datav from "@/layout/Datav";

const openRoutes = [
    {
        path: '/login',
        component: open,
        redirect: '/login',
        name: "login",
        meta: { title: 'page_login', classify: 'login', icon: 'login', affix: true, isHistoryNav:0,isShow: 0 },//登录
        children: [
            {
                path: '/login',
                component: () => import('@/views/login/index'),
                name: 'login',
                meta: { title: 'page_login', classify: 'login', icon: 'login', affix: true,isHistoryNav:0, isShow: 0 }//登录
            }
        ]
    },
    {
        path: '/loginEmployee',
        component: open,
        redirect: '/loginEmployee',
        name: "loginEmployee",
        meta: { title: 'page_login_employee', classify: 'loginEmployee', icon: 'loginEmployee', affix: true, isHistoryNav:0,isShow: 0 },//员工-登录
        children: [
            {
                path: '/loginEmployee',
                component: () => import('@/views/loginEmployee/index'),
                name: 'loginEmployee',
                meta: { title: 'page_login_employee', classify: 'loginEmployee', icon: 'loginEmployee', affix: true,isHistoryNav:0, isShow: 0 }//员工-登录
            }
        ]
    },
    {
        path: '/loginSelect',
        component: open,
        redirect: '/loginSelect',
        name: "loginSelect",
        meta: { title: 'page_login_select', classify: 'loginSelect', icon: 'loginSelect', affix: true, isHistoryNav:0,isShow: 0 },//登录选择
        children: [
            {
                path: '/loginSelect',
                component: () => import('@/views/loginSelect/index'),
                name: 'loginSelect',
                meta: { title: 'page_login_select', classify: 'loginSelect', icon: 'loginSelect', affix: true,isHistoryNav:0, isShow: 0 }//登录选择
            }
        ]
    },
    {
        path: '/printDetails',
        component: emptyPrint,
        redirect: '/printDetails',
        name: "printDetails",
        meta: { title: 'page_print_detail', classify: 'printDetails', icon: 'printDetails', affix: true, isShow: 0 },//打印详情
        children: [
            {
                path: '/printDetails/:id',
                component: () => import('@/views/printDetails/index'),
                name: 'printTable',
                meta: { title: 'page_print_detail', classify: 'printDetails', icon: 'printDetails', affix: true, isShow: 0 }//打印详情
            },
            {
                path: '/printDetails/index1/:id',
                component: () => import('@/views/printDetails/index1'),
                name: 'printTable1',
                meta: { title: 'page_print_detail', classify: 'printDetails', icon: 'printDetails', affix: true, isShow: 0 }//打印详情
            },
            {
                path: '/authPage',
                component: () => import('@/views/printDetails/authPage'),
                name: 'authPage',
                meta: { title: 'page_print_detail', classify: 'authPage', icon: 'authPage', affix: true, isShow: 0 }//打印详情
            }
        ]
    },
]
const importRoutes = filterByKey([
    {
        path: "/import",
        component: platform,
        redirect: "/import",
        name: "import",
        meta: {
            keepAlive: false,
            title: "tabbar16",//数据导入
            classify: "import",
            icon: "import",
            affix: true,
            level: 5,
            isShow: 1,
            authClassify: "import",
            table: "",
        },
        children: [
            {
                path: "/import",
                component: () => import("@/views/import/index"),
                name: "printIndex",
                meta: {
                    keepAlive: false,
                    title: "tabbar16",//数据导入
                    classify: "import",
                    icon: "import",
                    affix: true,
                    level: 5,
                    isShow: 1,
                    authClassify: "import",
                    table: "",
                },
            },
            {
                path: "/upload/:type",
                component: () => import("@/views/import/upload"),
                name: "uploadIndex",
                meta: {
                    keepAlive: false,
                    title: "tabbar16",//数据导入
                    classify: "print",
                    icon: "print",
                    affix: true,
                    level: 5,
                    isShow: 1,
                    authClassify: "print",
                    table: "",
                },
            },
        ],
    },
]);


const toolsRoutes1 = filterByKey([
    {
        path: '/',
        component:platform,
        redirect: '/home',
        name: "home",
        meta: { keepAlive: false,title: 'tabbar1', classify: 'home', icon: 'home', affix: true,isHistoryNav:0, isShow: 1 },//未完结红卡
        children: [
            {
                path: '/home',
                component: () => import('@/views/home/index'),
                name: 'homeIndex',
                meta: { keepAlive: false,title: 'tabbar1', classify: 'home', icon: 'home', affix: true,isHistoryNav:0, isShow: 1 }//未完结红卡
            },
            {
                path: '/home/detail/:id',
                component: () => import('@/views/home/detail'),
                name: 'homeDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'home', icon: 'home',isHistoryNav:0, affix: true, isShow: 1 }//详情
            }
        ]
    },
    {
        path: '/complete',
        component:platform,
        redirect: '/complete',
        name: "complete",
        meta: { keepAlive: false,title: 'tabbar2', classify: 'complete', icon: 'complete', affix: true,isHistoryNav:0, isShow: 1 ,authClassify: "complete"},//已完结红卡
        children: [
            {
                path: '/complete',
                component: () => import('@/views/complete/index'),
                name: 'completeIndex',
                meta: { keepAlive: false,title: 'tabbar2', classify: 'complete', icon: 'complete', affix: true,isHistoryNav:0, isShow: 1 ,authClassify: "complete"}//已完结红卡
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/complete/detail'),
                name: 'completeDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'complete', icon: 'complete',isHistoryNav:0, affix: true, isShow: 1,authClassify: "complete"  }//详情
            }
        ]
    },
    {
        path: "/datav",
        component: datav,
        redirect: "/datav/all",
        name: "datav",
        meta: {
            title: "活动数据",
            classify: "datav",
            icon: "datav",
            affix: true,
            isHistoryNav: 0,
            isShow: 0,
            role: 10,
            authClassify: "datav",
        },
        children: filterByKey([
            {
                path: "all",
                component: () => import("@/views/datav/all"),
                name: "datavIndex",
                meta: {
                    title: "数据统计",
                    classify: "datav",
                    icon: "datav",
                    affix: true,
                    isHistoryNav: 0,
                    isShow: 1,
                    role: 10,
                    authClassify: "datav",
                },
            },
        ]),
    },
])


const employeeRoutes = filterByKey([
    {
        path: '/employee',
        component:platform,
        redirect: '/employee/index',
        name: "employee",
        meta: { keepAlive: true,title: 'tabbar12', classify: 'employee', icon: 'employee', affix: true,isHistoryNav:1, isShow: 1 ,authClassify: "employee"},//员工管理
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/employee/index'),
                name: 'employeeIndex',
                meta: { keepAlive: true,title: 'tabbar12', classify: 'employee', icon: 'employee',isHistoryNav:1, affix: true, isShow: 1,authClassify: "employee" }//员工管理
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/employee/detail'),
                name: 'employeeDetail',
                meta: { keepAlive: true,title: 'title_detail', classify: 'employee', icon: 'employee',isHistoryNav:0, affix: true, isShow: 1,authClassify: "employee" }//员工详情
            }
        ])
    },
])

const deviceRoutes = filterByKey([
    {
        path: '/device',
        component:platform,
        redirect: '/device/index',
        name: "device",
        meta: { keepAlive: false,title: 'tabbar3', classify: 'device', icon: 'device', affix: true,isHistoryNav:1, isShow: 1,authClassify: "device" },//产品管理
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/device/index'),
                name: 'deviceIndex',
                meta: { keepAlive: false,title: 'tabbar3', classify: 'device', icon: 'device',isHistoryNav:1, affix: true, isShow: 1 ,authClassify: "device"}//产品管理
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/device/detail'),
                name: 'deviceDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'device', icon: 'device',isHistoryNav:0, affix: true, isShow: 1,authClassify: "device" }//产品详情
            }
        ])
    },
])

const registCardRoutes = filterByKey([
    {
        path: '/registCard',
        component:platform,
        redirect: '/registCard/index',
        name: "registCard",
        meta: { keepAlive: false,title: 'tabbar5', classify: 'registCard', icon: 'registCard', affix: true,isHistoryNav:1, isShow: 1,authClassify: "registCard" },//登记红卡
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/registCard/index'),
                name: 'registCardIndex',
                meta: { keepAlive: false,title: 'tabbar5', classify: 'registCard', icon: 'registCard',isHistoryNav:1, affix: true, isShow: 1,authClassify: "registCard" }//登记红卡
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/registCard/detail'),
                name: 'registCardDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'registCard', icon: 'registCard',isHistoryNav:0, affix: true, isShow: 1,authClassify: "registCard" }//红卡详情
            }
        ])
    },
])

const applyCardRoutes = filterByKey([
    {
        path: '/applyCard',
        component:platform,
        redirect: '/applyCard/index',
        name: "applyCard",
        meta: { keepAlive: false,title: 'tabbar4', classify: 'applyCard', icon: 'applyCard', affix: true,isHistoryNav:1, isShow: 1,authClassify: "applyCard" },//红卡管理
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/applyCard/index'),
                name: 'applyCardIndex',
                meta: { keepAlive: false,title: 'tabbar4', classify: 'applyCard', icon: 'applyCard',isHistoryNav:1, affix: true, isShow: 1,authClassify: "applyCard" }//红卡管理
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/applyCard/detail'),
                name: 'applyCardDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'applyCard', icon: 'applyCard',isHistoryNav:0, affix: true, isShow: 1,authClassify: "applyCard" }//红卡详情
            }
        ])
    },
])

const handleMRBRoutes = filterByKey([
    {
        path: '/handleMRB',
        component:platform,
        redirect: '/handleMRB/index',
        name: "handleMRB",
        meta: { keepAlive: false,title: 'tabbar6', classify: 'handleMRB', icon: 'handleMRB', affix: true,isHistoryNav:1, isShow: 1,authClassify: "handleMRB" },//MRB管理
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/handleMRB/index'),
                name: 'handleMRBIndex',
                meta: { keepAlive: false,title: 'tabbar6', classify: 'handleMRB', icon: 'handleMRB',isHistoryNav:1, affix: true, isShow: 1,authClassify: "handleMRB" }//MRB管理
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/handleMRB/detail'),
                name: 'handleMRBDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'handleMRB', icon: 'handleMRB',isHistoryNav:0, affix: true, isShow: 1,authClassify: "handleMRB" }//MRB处理详情
            }
        ])
    },
])

const repairRoutes = filterByKey([
    {
        path: '/repair',
        component:platform,
        redirect: '/repair/index',
        name: "repair",
        meta: { keepAlive: false,title: 'tabbar7', classify: 'repair', icon: 'repair', affix: true,isHistoryNav:1, isShow: 1,authClassify: "repair" },//返工
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/repair/index'),
                name: 'repairIndex',
                meta: { keepAlive: false,title: 'tabbar7', classify: 'repair', icon: 'repair',isHistoryNav:1, affix: true, isShow: 1,authClassify: "repair" }//返工
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/repair/detail'),
                name: 'repairDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'repair', icon: 'repair',isHistoryNav:0, affix: true, isShow: 1,authClassify: "repair" }//返工详情
            },
            {
                path: 'repairRecord',
                component: () => import('@/views/repair/repairRecord'),
                name: 'repairRecord',
                meta: { keepAlive: false,title: 'title_detail', classify: 'repair', icon: 'repair',isHistoryNav:0, affix: true, isShow: 1,authClassify: "repair" }//返工记录
            }
        ])
    },
])

const sqeRegistRoutes = filterByKey([
    {
        path: '/sqeRegist',
        component:platform,
        redirect: '/sqeRegist/index',
        name: "sqeRegist",
        meta: { keepAlive: false,title: 'tabbar9', classify: 'sqeRegist', icon: 'sqeRegist', affix: true,isHistoryNav:1, isShow: 1 ,authClassify: "sqeRegist"},//SQE登记
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/sqeRegist/index'),
                name: 'sqeRegistIndex',
                meta: { keepAlive: false,title: 'tabbar9', classify: 'sqeRegist', icon: 'sqeRegist',isHistoryNav:1, affix: true, isShow: 1,authClassify: "sqeRegist" }//SQE登记
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/sqeRegist/detail'),
                name: 'sqeRegistDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'sqeRegist', icon: 'sqeRegist',isHistoryNav:0, affix: true, isShow: 1,authClassify: "sqeRegist" }//SQE登记详情
            }
        ])
    },
])

const lossRoutes = filterByKey([
    {
        path: '/loss',
        component:platform,
        redirect: '/loss/index',
        name: "loss",
        meta: { keepAlive: false,title: 'tabbar10', classify: 'loss', icon: 'loss', affix: true,isHistoryNav:1, isShow: 1 ,authClassify: "loss"},//生产管理
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/loss/index'),
                name: 'lossIndex',
                meta: { keepAlive: false,title: 'tabbar10', classify: 'loss', icon: 'loss',isHistoryNav:1, affix: true, isShow: 1,authClassify: "loss" }//生产管理
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/loss/detail'),
                name: 'lossDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'loss', icon: 'loss',isHistoryNav:0, affix: true, isShow: 1,authClassify: "loss" }//生产管理详情
            }
        ])
    },
])

const reworkRoutes = filterByKey([
    {
        path: '/rework',
        component:platform,
        redirect: '/rework/index',
        name: "rework",
        meta: { keepAlive: false,title: 'tabbar8', classify: 'rework', icon: 'rework', affix: true,isHistoryNav:1, isShow: 1 ,authClassify: "rework"},//返修质量管理
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/rework/index'),
                name: 'reworkIndex',
                meta: { keepAlive: false,title: 'tabbar8', classify: 'rework', icon: 'rework',isHistoryNav:1, affix: true, isShow: 1 ,authClassify: "rework"}//返修质量管理
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/rework/detail'),
                name: 'reworkDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'rework', icon: 'rework',isHistoryNav:0, affix: true, isShow: 1 ,authClassify: "rework"}//返修质量管理详情
            }
        ])
    },
])

const pobManageRoutes = filterByKey([
    {
        path: '/pobManage',
        component:platform,
        redirect: '/pobManage/index',
        name: "pobManage",
        meta: { keepAlive: false,title: 'tabbar11', classify: 'pobManage', icon: 'pobManage', affix: true,isHistoryNav:1, isShow: 1 ,authClassify: "pobManage"},//POB登记
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/pobManage/index'),
                name: 'pobManageIndex',
                meta: { keepAlive: false,title: 'tabbar11', classify: 'pobManage', icon: 'pobManage',isHistoryNav:1, affix: true, isShow: 1,authClassify: "pobManage" }//POB登记
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/pobManage/detail'),
                name: 'pobManageDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'pobManage', icon: 'pobManage',isHistoryNav:0, affix: true, isShow: 1 ,authClassify: "pobManage"}//POB登记详情
            }
        ])
    },
])

const problemDescriptionRoutes = filterByKey([
    {
        path: '/problemDescription',
        component:platform,
        redirect: '/problemDescription/index',
        name: "problemDescription",
        meta: { keepAlive: false,title: 'tabbar13', classify: 'problemDescription', icon: 'problemDescription', affix: true,isHistoryNav:1, isShow: 1,authClassify: "problemDescription"  },//不良描述
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/problemDescription/index'),
                name: 'problemDescriptionIndex',
                meta: { keepAlive: false,title: 'tabbar13', classify: 'problemDescription', icon: 'problemDescription',isHistoryNav:1, affix: true, isShow: 1,authClassify: "problemDescription"  }//不良描述
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/problemDescription/detail'),
                name: 'problemDescriptionDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'problemDescription', icon: 'problemDescription',isHistoryNav:0, affix: true, isShow: 1,authClassify: "problemDescription"  }//不良描述详情
            }
        ])
    },
])

const sopRoutes = filterByKey([
    {
        path: '/sop',
        component:platform,
        redirect: '/sop/index',
        name: "sop",
        meta: { keepAlive: false,title: 'tabbar14', classify: 'sop', icon: 'sop', affix: true,isHistoryNav:1, isShow: 1 ,authClassify: "sop" },//Sop清单
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/sop/index'),
                name: 'sopIndex',
                meta: { keepAlive: false,title: 'tabbar14', classify: 'sop', icon: 'sop',isHistoryNav:1, affix: true, isShow: 1,authClassify: "sop" }//Sop清单
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/sop/detail'),
                name: 'sopDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'sop', icon: 'sop',isHistoryNav:0, affix: true, isShow: 1,authClassify: "sop" }//Sop清单详情
            }
        ])
    },
])

const rootCauseRoutes = filterByKey([
    {
        path: '/rootCause',
        component:platform,
        redirect: '/rootCause/index',
        name: "rootCause",
        meta: { keepAlive: false,title: '根本原因', classify: 'rootCause', icon: 'rootCause', affix: true,isHistoryNav:1, isShow: 0 },//根本原因
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/rootCause/index'),
                name: 'rootCauseIndex',
                meta: { keepAlive: false,title: '根本原因', classify: 'rootCause', icon: 'rootCause',isHistoryNav:1, affix: true, isShow: 1 }//根本原因
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/rootCause/detail'),
                name: 'rootCauseDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'rootCause', icon: 'rootCause',isHistoryNav:0, affix: true, isShow: 1 }//根本原因详情
            }
        ])
    },
])

const processesRoutes = filterByKey([
    {
        path: '/processes',
        component:platform,
        redirect: '/processes/index',
        name: "processes",
        meta: { keepAlive: false,title: 'tabbar15', classify: 'processes', icon: 'processes', affix: true,isHistoryNav:1, isShow: 1,authClassify: "processes" },//工序描述
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/processes/index'),
                name: 'processesIndex',
                meta: { keepAlive: false,title: 'tabbar15', classify: 'processes', icon: 'processes',isHistoryNav:1, affix: true, isShow: 1,authClassify: "processes" }//工序描述
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/processes/detail'),
                name: 'processesDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'processes', icon: 'processes',isHistoryNav:0, affix: true, isShow: 1,authClassify: "processes" }//工序描述详情
            }
        ])
    },
])
const supplierRoutes = filterByKey([
    {
        path: '/supplier',
        component:platform,
        redirect: '/supplier/index',
        name: "supplier",
        meta: { keepAlive: false,title: '供应商', classify: 'supplier', icon: 'supplier', affix: true,isHistoryNav:1, isShow: 0 },
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/supplier/index'),
                name: 'supplierIndex',
                meta: { keepAlive: false,title: '供应商', classify: 'supplier', icon: 'supplier',isHistoryNav:1, affix: true, isShow: 1 }
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/supplier/detail'),
                name: 'supplierDetail',
                meta: { keepAlive: false,title: '供应商详情', classify: 'supplier', icon: 'supplier',isHistoryNav:0, affix: true, isShow: 1 }
            }
        ])
    },
])
const teamRoutes = filterByKey([
    {
        path: '/team',
        component:platform,
        redirect: '/team/index',
        name: "team",
        meta: { keepAlive: false,title: '团队管理', classify: 'team', icon: 'team', affix: true,isHistoryNav:1,isShow: 0,role:9},
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/team/index'),
                name: 'teamIndex',
                meta: { keepAlive: false,title: '团队管理', classify: 'team', icon: 'team', affix: true,isHistoryNav:1,isShow: 1 ,role:9}
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/team/detail'),
                name: 'teamDetail',
                meta: {keepAlive: false,title: '团队详情', classify: 'team', icon: 'team', affix: true,isHistoryNav:0,isShow: 1,role:9}
            },
        ])
    },
    {
        path: '/admin',
        component:platform,
        redirect: '/admin/index',
        name: "admin",
        meta: { keepAlive: false,title: '团队管理员', classify: 'admin', icon: 'admin', affix: true,isHistoryNav:1, isShow: 0 },
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/admin/index'),
                name: 'adminIndex',
                meta: { keepAlive: false,title: '管理员管理', classify: 'admin', icon: 'admin',isHistoryNav:1, affix: true, isShow: 1}
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/admin/detail'),
                name: 'adminDetail',
                meta: { keepAlive: false,title: '管理员详情', classify: 'admin', icon: 'admin',isHistoryNav:0, affix: true, isShow: 1 }
            }
        ])
    },
])

const systemRoutes = filterByKey([
    {
        path: '/boss',
        component: platform,
        redirect: '/boss/index',
        name: "boss",
        meta: {keepAlive: false,title: 'tabbar17', classify: 'boss', icon: 'boss', affix: true,isHistoryNav:1, level: 2, role: 2, isShow: 1},//平台管理员
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/boss/index'),
                name: 'bossIndex',
                meta: {keepAlive: false,title: 'tabbar17', classify: 'boss', icon: 'boss', affix: true, isHistoryNav:1,level: 2, role: 2, isShow: 1}//平台管理员
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/boss/detail'),
                name: 'bossDetail',
                meta: {keepAlive: false,title: 'title_add_admin', classify: 'boss', icon: 'boss', affix: true,isHistoryNav:0, level: 2, role: 2, isShow: 1}
            }
        ])
    },
    {
        path: '/bossAuth',
        component: platform,
        redirect: '/bossAuth/index/0',
        name: "bossAuth",
        meta: {keepAlive: false,title: 'tabbar18', classify: 'bossAuth', icon: 'bossAuth', affix: true,isHistoryNav:1, level: 2, role: 2, isShow: 1},//授权管理
        children: filterByKey([
            {
                path: 'index/:id',
                component: () => import('@/views/bossAuth/index'),
                name: 'bossAuthIndex',
                meta: {keepAlive: false,title: 'tabbar18', classify: 'bossAuth', icon: 'bossAuth', affix: true,isHistoryNav:1, level: 2, role: 2, isShow: 1}//授权管理
            },
            {
                path: 'options',
                component: () => import('@/views/bossAuth/options'),
                name: 'bossAuthOptions',
                meta: {keepAlive: false,title: 'title_category', classify: 'bossAuth', icon: 'bossAuth', affix: true,isHistoryNav:0, level: 2, role: 2, isShow: 1}
            }
        ])
    },
    {
        path: '/language',
        component:platform,
        redirect: '/language/index',
        name: "language",
        meta: { keepAlive: false,title: 'tabbar19', classify: 'language', icon: 'language', affix: true,isHistoryNav:1, isShow: 1,authClassify: "language" },//国际化
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/language/index'),
                name: 'languageIndex',
                meta: { keepAlive: false,title: 'tabbar19', classify: 'language', icon: 'language',isHistoryNav:1, affix: true, isShow: 1,authClassify: "language" }//国际化
            },
            {
                path: 'detail/:id',
                component: () => import('@/views/language/detail'),
                name: 'languageDetail',
                meta: { keepAlive: false,title: 'title_detail', classify: 'language', icon: 'language',isHistoryNav:0, affix: true, isShow: 1,authClassify: "language" }//国际化详情
            }
        ])
    },
    {
        path: '/system',
        component:platform,
        redirect: '/system/index',
        name: "system",
        meta: { keepAlive: false,title: '系统配置', classify: 'system', icon: 'system', affix: true,isHistoryNav:1, isShow: 0 },
        children: filterByKey([
            {
                path: 'index',
                component: () => import('@/views/system/index'),
                name: 'systemIndex',
                meta: { keepAlive: false,title: '系统配置', classify: 'system', icon: 'system', affix: true,isHistoryNav:1, isShow: 1 }
            },
        ])
    },
])

const constantRoutes = [
    ...openRoutes,
    ...importRoutes,
    ...toolsRoutes1,
    ...employeeRoutes,
    ...deviceRoutes,
    ...registCardRoutes,
    ...applyCardRoutes,
    ...handleMRBRoutes,
    ...repairRoutes,
    ...sqeRegistRoutes,
    ...lossRoutes,
    ...reworkRoutes,
    ...pobManageRoutes,
    ...problemDescriptionRoutes,
    ...sopRoutes,
    ...rootCauseRoutes,
    ...supplierRoutes,
    ...processesRoutes,
    ...teamRoutes,
    ...systemRoutes
];

const router = createRouter({
    history: createWebHashHistory(),
    routes: constantRoutes
});

//TODO: 先实现下一级的过滤，
function filterByKey(arrayObj){
    arrayObj = arrayObj.filter((item)=>{
        return item["meta"]["isShow"] !== 0
    });

    return arrayObj
}

export {
    openRoutes,
    importRoutes,
    toolsRoutes1,
    employeeRoutes,
    deviceRoutes,
    registCardRoutes,
    applyCardRoutes,
    handleMRBRoutes,
    repairRoutes,
    sqeRegistRoutes,
    lossRoutes,
    reworkRoutes,
    pobManageRoutes,
    problemDescriptionRoutes,
    sopRoutes,
    rootCauseRoutes,
    supplierRoutes,
    processesRoutes,
    teamRoutes,
    systemRoutes,
    constantRoutes,
    router
}